import { SetReStateAction } from '@raulpesilva/re-state/types/core';
import { DispatchReState } from '@raulpesilva/re-state/types/react/types';

import useGlobalStorage from './storage/useGlobalStorage';

export default function useLoading() {
	const [loading, setLoading] = useGlobalStorage('loading', false);
	return [loading, setLoading] as [boolean, DispatchReState<SetReStateAction<boolean>>];
}
